import React from 'react';
import PropTypes from 'prop-types';
import { basePageWrap } from '../BasePage';
import isEmpty from '../../utils/isEmpty';
import styles from './AreaNewsListPage.module.scss';
import NewsListModule from '../../components/NewsListModule';
import Pagination from '../../components/Pagination';
import Breadcrumbs from '../../components/Breadcrumbs';
import Select from '../../components/Select';
import i18n from '../../i18n';

const AreaNewsListPage = ({
    breadcrumbs,
    title,
    preamble,
    news,
    filters,
    isAreaOrProject,
}) => {
    const preHeadlineText = isAreaOrProject
        ? i18n.t('newsListPage.areaProjectHeadline')
        : '';

    return (
        <div className={styles['AreaNewsListPage']}>
            <Breadcrumbs {...breadcrumbs} />
            <div className={styles['AreaNewsListPage__Container']}>
                <h1 className={styles['AreaNewsListPage__Title']}>
                    {preHeadlineText}
                    {title}
                </h1>
                <div className={styles['AreaNewsListPage__Preamble']}>
                    {preamble}
                </div>
            </div>

            {!isEmpty(filters) && filters.areas.length > 1 && (
                <form
                    className={styles['AreaNewsListPage__Filters']}
                    id="filter_form"
                >
                    <Select
                        options={filters.areas.map((i) => ({
                            label: i.area,
                            value: i.id,
                        }))}
                        hideLabel={true}
                        id="id_area"
                        name="area"
                        labelAll={'Alla områden'}
                        defaultValue={filters.defaultArea}
                        label={'Filtrera på område'}
                    />

                    <button
                        type="submit"
                        className={styles['AreaNewsListPage__Filter']}
                    >
                        Filtrera
                    </button>
                </form>
            )}

            <NewsListModule {...news} filters={filters} />
            {news.pagination && news.pagination.pages > 1 && (
                <Pagination {...news.pagination} />
            )}
        </div>
    );
};

AreaNewsListPage.propTypes = {
    title: PropTypes.string,
    preamble: PropTypes.string,
    news: PropTypes.object,
    filters: PropTypes.object,
};

AreaNewsListPage.defaultProps = {
    title: '',
    preamble: '',
    news: {},
    filters: {},
};

export default basePageWrap(AreaNewsListPage);
